module.exports = __webpack_public_path__ + "static/media/ShopImageGeneric.27e3a611.png";